// extracted by mini-css-extract-plugin
export var explainable = "_jf-a";
export var printerCard = "_jf-1";
export var printerCardConfigured = "_jf-2";
export var printerCardError = "_jf-3";
export var printerCardsContainer = "_jf-0";
export var printerIcon = "_jf-8";
export var printerIconConfigured = "_jf-5";
export var printerIconContainer = "_jf-4";
export var printerIconError = "_jf-6";
export var printerIconUnconfigured = "_jf-7";
export var workstationsTableCard = "_jf-9";